import { render, staticRenderFns } from "./WorkflowIframe - 副本.vue?vue&type=template&id=6035a90e&scoped=true"
import script from "./WorkflowIframe - 副本.vue?vue&type=script&lang=js"
export * from "./WorkflowIframe - 副本.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6035a90e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6035a90e')) {
      api.createRecord('6035a90e', component.options)
    } else {
      api.reload('6035a90e', component.options)
    }
    module.hot.accept("./WorkflowIframe - 副本.vue?vue&type=template&id=6035a90e&scoped=true", function () {
      api.rerender('6035a90e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tools/WorkflowIframe - 副本.vue"
export default component.exports